import { Facet, HawkSearchComponents, TabsComponentConfig, TabsComponentModel } from '@models';
import { searchService } from '@services';
import { BaseComponent } from '../../base.component';
import defaultHtml from './tabs.component.hbs';

export class TabsComponent extends BaseComponent<TabsComponentConfig, Facet, TabsComponentModel> {
    protected override componentName: keyof HawkSearchComponents = 'tabs';
    protected override defaultHtml = defaultHtml;
    protected override bindFromEvent = true;

    protected override renderContent(): boolean {
        return !!this.data?.values?.length;
    }

    protected override getContentModel(): TabsComponentModel {
        return {
            displayCount: this.data!.displayCount ?? true,
            tabs: this.data!.values ?? []
        };
    }

    protected bindChildElements(): void {
        this.rootElement.querySelectorAll('[hawksearch-tab-value]').forEach((e) => {
            e.addEventListener('click', (event: Event) => {
                event.preventDefault();

                const element = event.currentTarget as HTMLElement;
                const value = element.getAttribute('hawksearch-tab-value');

                searchService.selectTab(value ?? undefined);
            });
        });
    }
}
